function esc(str) {
  return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export function generateCode(dni) {
  return `EPG-${new Date().getFullYear()}-${dni}`;
}

export function openFicha({ epgCode, apiCode, nombre, apellidos, dni, email, cell, programa, proceso, fecha }) {
  const html = `<!DOCTYPE html>
<html lang="es">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Ficha de Postulación — ${esc(epgCode)}</title>
<style>
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'Segoe UI',Arial,sans-serif;background:#f0f2f5;color:#1a1a1a;font-size:14px}
  @media print{body{background:#fff}.no-print{display:none!important}.page{box-shadow:none!important;border:none!important;max-width:100%!important;margin:0!important;border-radius:0!important}}
  .page{max-width:740px;margin:32px auto;background:#fff;border-radius:10px;overflow:hidden;box-shadow:0 4px 24px rgba(0,0,0,.12);border:1px solid #e0e0e0}
  .hdr{background:linear-gradient(135deg,#004d26 0%,#00793c 100%);color:#fff;padding:24px 32px;display:flex;align-items:center;gap:16px}
  .hdr-icon{font-size:40px;flex-shrink:0}
  .hdr-info{flex:1}
  .hdr-info h1{font-size:16px;font-weight:700;line-height:1.3}
  .hdr-info p{font-size:12px;opacity:.8;margin-top:3px}
  .hdr-code{background:rgba(255,255,255,.15);border:1px solid rgba(255,255,255,.25);border-radius:8px;padding:10px 18px;text-align:center;flex-shrink:0}
  .hdr-code .cl{font-size:10px;text-transform:uppercase;letter-spacing:.1em;opacity:.75;margin-bottom:4px}
  .hdr-code .cv{font-size:18px;font-weight:800;letter-spacing:.04em}
  .alert{margin:20px 28px;padding:14px 18px;background:#fffbeb;border:1px solid #fcd34d;border-left:5px solid #f59e0b;border-radius:6px}
  .alert-title{font-weight:700;color:#92400e;font-size:13px;margin-bottom:6px}
  .alert p{color:#78350f;font-size:12.5px;line-height:1.65}
  .alert-critical{display:block;margin-top:8px;font-weight:700;color:#b45309}
  .section{padding:16px 28px;border-top:1px solid #f0f0f0}
  .s-title{font-size:10.5px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:#00793c;margin-bottom:14px;padding-bottom:6px;border-bottom:2px solid #dcfce7}
  .grid{display:grid;grid-template-columns:1fr 1fr;gap:12px 24px}
  .field .fl{font-size:10px;color:#888;text-transform:uppercase;letter-spacing:.07em;margin-bottom:3px}
  .field .fv{font-size:14px;font-weight:600;color:#111}
  .status-badge{display:inline-block;background:#fef9c3;color:#854d0e;border:1px solid #fde68a;border-radius:20px;padding:3px 12px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.06em}
  .ftr{padding:14px 28px;border-top:1px solid #e8e8e8;background:#fafafa;display:flex;justify-content:space-between;align-items:center}
  .ftr-text{font-size:11px;color:#aaa}
  .btn-print{background:#00793c;color:#fff;border:none;border-radius:6px;padding:9px 20px;font-size:13px;font-weight:600;cursor:pointer;display:flex;align-items:center;gap:6px}
  .btn-print:hover{background:#005c2e}
</style>
</head>
<body>
<div class="page">
  <div class="hdr">
    <div class="hdr-icon">🎓</div>
    <div class="hdr-info">
      <h1>Universidad Nacional de San Martín</h1>
      <p>Escuela de Posgrado — Comprobante de Registro de Postulación</p>
    </div>
    <div class="hdr-code">
      <div class="cl">Código EPG</div>
      <div class="cv">${esc(epgCode)}</div>
    </div>
  </div>

  <div class="alert">
    <div class="alert-title">⚠ Aviso importante — Lea detenidamente</div>
    <p>
      Este comprobante acredita únicamente que su solicitud de postulación fue <strong>recibida y registrada</strong>
      en el sistema informático de la Escuela de Posgrado – UNSM.
      La información declarada y los documentos adjuntos <strong>serán evaluados</strong> por el comité
      de admisión en las fechas establecidas en el cronograma del proceso.
      <span class="alert-critical">⛔ Este documento NO garantiza su admisión al programa ni la validez
      de los documentos presentados. El resultado será comunicado por los canales oficiales de la institución.</span>
    </p>
  </div>

  <div class="section">
    <div class="s-title">Datos del Postulante</div>
    <div class="grid">
      <div class="field"><div class="fl">Apellidos</div><div class="fv">${esc(apellidos)}</div></div>
      <div class="field"><div class="fl">Nombres</div><div class="fv">${esc(nombre)}</div></div>
      <div class="field"><div class="fl">N° Documento (DNI)</div><div class="fv">${esc(dni)}</div></div>
      <div class="field"><div class="fl">Estado</div><div class="fv"><span class="status-badge">Pendiente de evaluación</span></div></div>
      <div class="field"><div class="fl">Correo Electrónico</div><div class="fv">${esc(email) || '—'}</div></div>
      <div class="field"><div class="fl">Teléfono / Celular</div><div class="fv">${esc(cell) || '—'}</div></div>
    </div>
  </div>

  <div class="section">
    <div class="s-title">Proceso de Admisión</div>
    <div class="grid">
      <div class="field"><div class="fl">Proceso</div><div class="fv">${esc(proceso) || '—'}</div></div>
      <div class="field"><div class="fl">Programa al que Postula</div><div class="fv">${esc(programa) || '—'}</div></div>
      <div class="field"><div class="fl">Fecha de Registro</div><div class="fv">${esc(fecha)}</div></div>
      <div class="field"><div class="fl">Código de Sistema</div><div class="fv">${esc(apiCode) || '—'}</div></div>
    </div>
  </div>

  <div class="ftr">
    <div class="ftr-text">EPG–UNSM · Documento generado electrónicamente · ${new Date().getFullYear()}</div>
    <button class="btn-print no-print" onclick="window.print()">🖨 Imprimir / Guardar PDF</button>
  </div>
</div>
</body>
</html>`;

  const win = window.open('', '_blank', 'width=840,height=1080,scrollbars=yes,resizable=yes');
  if (!win) {
    alert('Active las ventanas emergentes en su navegador para descargar la ficha.');
    return;
  }
  win.document.write(html);
  win.document.close();
  win.focus();
  setTimeout(() => win.print(), 700);
}
